module.exports = __webpack_public_path__ + "img/totallymoney.ed3f2e19.svg";